import React from 'react';
import { Link } from 'wouter';
import { Button } from '@/components/ui/button';
import { 
  Mail, 
  ChevronRight,
  FileText,
  Users
} from 'lucide-react';
import SuperAdminLayout from '@/components/admin/super-admin-layout';

export default function Campaigns() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SuperAdminLayout>
        <CampaignsContent />
      </SuperAdminLayout>
    </div>
  );
}

function CampaignsContent() {
  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Email Campaigns</h1>
          <p className="text-muted-foreground mt-2">
            Create and manage email campaigns for your tenants
          </p>
        </div>
        <Link href="/admin/email/campaigns">
          <Button>
            <Mail className="mr-2 h-4 w-4" />
            Manage Campaigns
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 hover:shadow-md transition duration-150 p-6">
          <div className="rounded-full bg-blue-100 w-12 h-12 flex items-center justify-center mb-4">
            <Mail className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="text-lg font-medium mb-2">Announcement Campaigns</h3>
          <p className="text-slate-600 mb-4">
            Send important announcements and updates to your tenants
          </p>
          <Link href="/admin/email/campaigns?type=announcement">
            <Button variant="outline" className="w-full">
              Create Announcement
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-slate-200 hover:shadow-md transition duration-150 p-6">
          <div className="rounded-full bg-green-100 w-12 h-12 flex items-center justify-center mb-4">
            <FileText className="h-6 w-6 text-green-600" />
          </div>
          <h3 className="text-lg font-medium mb-2">Offer Campaigns</h3>
          <p className="text-slate-600 mb-4">
            Send special offers and promotions to specific tenant groups
          </p>
          <Link href="/admin/email/campaigns?type=offer">
            <Button variant="outline" className="w-full">
              Create Offer
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-slate-200 hover:shadow-md transition duration-150 p-6">
          <div className="rounded-full bg-purple-100 w-12 h-12 flex items-center justify-center mb-4">
            <Users className="h-6 w-6 text-purple-600" />
          </div>
          <h3 className="text-lg font-medium mb-2">Targeted Campaigns</h3>
          <p className="text-slate-600 mb-4">
            Create targeted campaigns based on subscription plans or status
          </p>
          <Link href="/admin/email/campaigns?type=targeted">
            <Button variant="outline" className="w-full">
              Create Targeted Campaign
              <ChevronRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-6">
        <h3 className="text-lg font-medium mb-4">Recent Campaigns</h3>
        <div className="border rounded-md">
          <div className="grid grid-cols-4 border-b px-4 py-3 font-medium">
            <div>Campaign</div>
            <div>Type</div>
            <div>Status</div>
            <div>Performance</div>
          </div>
          <div className="px-4 py-12 text-center text-muted-foreground">
            No campaigns found. Create your first campaign!
          </div>
        </div>
      </div>
    </div>
  );
}